import React from "react";
import styled from "@emotion/styled";
import { Box } from "../../Box";
import { Button } from "../../Button";
export function Container(props) {
    const { children, onClick } = props;
    return (React.createElement(Box, { w: "100%", gap: "18px", display: "flex", flexDir: "column", alignItems: "center", onClick: onClick }, children));
}
export const Header = {
    Element: styled.div `
    width: 100%;
    height: 30px;

    display: flex;
    justify-content: center;
    align-items: center;

    p {
      width: 90px;
      text-align: center;
    }
  `,
    Section: styled.div `
    width: auto;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    button {
      background-color: transparent;
      border: none;
      font-size: 16px;

      cursor: pointer;
    }
  `,
};
export const Main = {
    Container: styled.div `
    width: 350px;
    height: 350px;
  `,
    WeekHeader: styled.div `
    width: 100%;
    height: 40px;
    display: flex;
  `,
    Grid: styled.div `
    display: flex;
    flex-wrap: wrap;
  `,
};
const defaultStyles = {
    "span:not(:last-child)": {
        margin: 0,
        marginRight: -6,
    },
    "> div": {
        display: "flex",
        overflow: "visible",
        height: "33%",
    },
};
export function DayButton(props) {
    const { isSelected, isDisabled, isActive, onClick, isToday, children, colorScheme, } = props;
    return (React.createElement(Button, { css: defaultStyles, w: "50px", h: "50px", display: "flex", flexDir: "column", onClick: onClick, colorScheme: colorScheme, 
        // eslint-disable-next-line no-nested-ternary
        color: isSelected ? "white" : !isActive ? "gray.400" : "gray.600", fontWeight: isToday ? "bolder" : "normal", variant: isSelected ? "solid" : "ghost", p: "7px", size: "md", pointerEvents: isDisabled ? "none" : "auto" }, children));
}
//# sourceMappingURL=styles.js.map